import {
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { Button, Select, Space, Steps, Tooltip, Typography } from "antd";
import React, { useEffect, useState, useMemo, useRef } from "react";
import { wizard } from "../../interfaces/IPreAuth";
import "./index.css";
import EnhancementContainer from "../../containers/patient/EnhancementContainer";
import DischargeContainer from "../../containers/patient/DischargeContainer";
import PreAuthClaimContainer from "../../containers/patient/PreAuth/PreAuthClaimContainer";
import PreAuthClaimContainerIhx from "../../containers/patient/PreAuthIhx/PreAuthCLaimContainerIhx";
import PreAuthScreenContainer from "./PreAuth/PreAuthScreenContainer";
import { useUserFunctionalities } from "../../utils/UserFunctionalities";
import {
  wizardStepsCghsIp,
  wizardStepsCghsOp,
  wizardStepsEchs,
  wizardStepsEchsOp,
  wizardStepsStarHealth,
} from "../../props/PreAuthProps";
import { AppDispatch, RootState } from "../../store/store";
import { useDispatch, useSelector } from "react-redux";
import ExtraDetails from "./ExtraDetails";
// import EnhancementContainerForCghs from "../../containers/patient/EnhancementContainerForCghs";
import NewEnhancementModal from "./Enhancement/NewEnhancementModal";
import NewEnhancementModalForCghs from "./Enhancement/NewEnhancementModalForCghs";
import PreAuthQueryForCghs from "./PreAuth-query/PreAuthQueryForCghs";
import "antd/dist/reset.css";
import EnhancementList from "./Enhancement/EnhancementListForCghsCase";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import PatientDetailsContainer from "../../containers/patient/PatientDetailsContainer";
import { setCurrentStep } from "../../models/preAuthSlice";
import EnhancementProcedureForCghsContainer from "../../containers/patient/EnhancementProcedureForCghsContainer";
import SettlementContainer from "../../containers/Settlement/SettlementContainer";
import PreAuthClaimContainerEchs from "../../containers/patient/PreAuthIhx/PreAuthCLaimContainerEchs";
import PreAuthAyushConatiner from "../../containers/patient/PreAuthAyushman/PreAuthAyushContainer";
import PreAuthClaimContainerAyushB from "../../containers/patient/PreAuthAyushman/PreAuthCLaimContainerAyushB";
import { resetAyushState } from "../../models/ayushmanBSlice";
import PreAuthCghsContainer from "../../containers/patient/PreAuthCghs/PreAuthCghsContainer";
import RegistrationContainerAyushB from "../../containers/patient/PreAuthAyushman/RegistrationContainerAyushB";

const { Title } = Typography;
const { Option } = Select;

// export const getWizardSteps = (hasEnhancement: boolean) => {
//   const baseSteps = [
//     {
//       canNavigate: true,
//       completed: true,
//       steps: 0,
//       title: "BASIC DETAILS",
//     },
//     {
//       canNavigate: true,
//       completed: true,
//       steps: 1,
//       title: "PRE-AUTH",
//     },
//   ];

//   const enhancementSteps = hasEnhancement
//     ? [
//         {
//           canNavigate: true,
//           completed: true,
//           steps: 2,
//           title: "PRE-AUTH QUERY",
//         },
//         {
//           canNavigate: true,
//           completed: true,
//           steps: 3,
//           title: "ENHANCEMENT",
//         },
//       ]
//     : [];

//   const finalSteps = [
//     {
//       canNavigate: true,
//       completed: false,
//       steps: hasEnhancement ? 4 : 2,
//       title: "DISCHARGE",
//     },
//     {
//       canNavigate: false,
//       completed: false,
//       steps: hasEnhancement ? 5 : 3,
//       title: "CLAIM",
//     },
//     // {
//     //   canNavigate: false,
//     //   completed: false,
//     //   steps: hasEnhancement ? 6 : 4,
//     //   title: "INVOICE & RECONCILIATION",
//     // },
//   ];

//   return [...baseSteps, ...enhancementSteps, ...finalSteps];
// };

type PreAuthProps = {
  currentStep: number;
  wizardSteps: Array<wizard>;
  next: CallableFunction;
  prev: CallableFunction;
  urlLink: string;
  setUrlLink: CallableFunction;
  handleInitiatePreAuth: CallableFunction;
  initiateToPreAuth: boolean;
  isCghs: boolean;
  claimId: string | null;
  setClaimId: CallableFunction;
  regId: string | null;
  setRegId: CallableFunction;
  visitType: string | undefined;
  schemeName: string | undefined;
  patientDetails?: any;
  completedStep?: number;
  dischargeId?: number | null;
  isEditing: boolean;
  statusOptions: { id: number; state: string }[] | null;
  selectedStatusValue: { id: number; state: string } | null;
  currentStatus: string | null;
  handleEditClick: () => void;
  handleChange: (value: number) => void;
  handleCancelClick: () => void;
  handleSaveClick: () => void;
  // setCallVisit: CallableFunction;
  newSteps: any;
  setWizards: any;
  handleCurrentStep: CallableFunction;
  fetchStepper: CallableFunction;
  stepperForStatus: CallableFunction;
};

const PreAuthStepper: React.FC<PreAuthProps> = (props) => {
  const dispatch = useDispatch<AppDispatch>();
  const { hasFunctionality, reloadFunctionalities } = useUserFunctionalities();
  const [localWizardSteps, setLocalWizardSteps] = useState<Array<wizard>>([]);
  const [stepsContent, setStepsContent] = useState<Array<any>>([]);
  const [moveToNext, setMoveToNext] = useState<Boolean>(false);
  const [nextStageDetails, setNextStageDetails] = useState<any>(null);
  const { preAuth, patients } = useSelector((state: RootState) => state);

  useEffect(() => {
    reloadFunctionalities();
  }, [reloadFunctionalities]);
  const currentStep = preAuth.currentStep;

  const handleNextByIframe = () => {
    if (currentWizardStep?.canNavigate || true) {
      if (currentWizardStep?.steps === 0) {
        props?.handleInitiatePreAuth();
      } else {
        props?.next();
      }
    }

    setMoveToNext(false);
  };
  
  useEffect(() => {
    return () => {
      dispatch(resetAyushState());
    };
  }, [dispatch]);

  useEffect(() => {
    setNextStageDetails(props?.newSteps?.visitStages?.[currentStep + 1]);
  }, [preAuth?.currentStep, props?.newSteps?.visitStages]);

  useEffect(() => {
    if (moveToNext) handleNextByIframe();
  }, [moveToNext]);

  const topDivRef = useRef<HTMLDivElement>(null);
  const [renderToTop, setRenderToTop] = useState<string | null>("");

  // useEffect(() => {
  //   if (renderToTop && topDivRef.current) {
  //     topDivRef.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "start",
  //     });
  //   }
  // }, [renderToTop]);

  useEffect(() => {
    if (renderToTop && topDivRef.current) {
      const scale = 0.67;

      const rect = topDivRef.current.getBoundingClientRect();
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const targetScroll = rect.top * scale + scrollTop;

      window.scrollTo({
        top: targetScroll,
        behavior: "smooth",
      });
    }
  }, [renderToTop]);

  const scrollToTopDiv = () => {
    if (topDivRef.current) {
      topDivRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  // Update wizard steps when scheme or access changes
  // useEffect(() => {
  //   const handleStepsUpdate = () => {
  //     const accessModules = JSON.parse(
  //       localStorage.getItem("accessModules") || "null"
  //     );
  //     const hasEnhancement = accessModules?.enhancementSubmission;

  //     let newSteps: Array<wizard> = [];

  //     if (props.schemeName?.toUpperCase() === "MEDI ASSIST") {
  //       newSteps = getWizardSteps(hasEnhancement);
  //     } else if (
  //       props.schemeName?.toUpperCase() === "CGHS" ||
  //       props.schemeName?.toUpperCase() === "CAPF"
  //     ) {
  //       if (props.visitType === "OP") {
  //         newSteps = wizardStepsCghsOp;
  //       } else if (
  //         props.visitType?.toUpperCase() === "IP" ||
  //         props.visitType?.toUpperCase() === "EMERGENCY"
  //       ) {
  //         newSteps = wizardStepsCghsIp;
  //       }
  //     } else if (props.schemeName?.toUpperCase() === "STAR HEALTH") {
  //       newSteps = wizardStepsStarHealth;
  //     } else if (props.schemeName?.toUpperCase() === "ECHS") {
  //       if (props.visitType === "OP") {
  //         newSteps = wizardStepsEchsOp;
  //       } else if (
  //         props.visitType?.toUpperCase() === "IP" ||
  //         props.visitType?.toUpperCase() === "EMERGENCY"
  //       ) {
  //         newSteps = wizardStepsEchs;
  //       }
  //     }

  //     // setLocalWizardSteps(newSteps);
  //     // updateStepsContent(newSteps, hasEnhancement);
  //   };

  //   handleStepsUpdate();

  //   window.addEventListener("storage", handleStepsUpdate);
  //   return () => {
  //     window.removeEventListener("storage", handleStepsUpdate);
  //   };
  // }, [props.schemeName, props.visitType, props?.urlLink]);

  useEffect(() => {
    updateStepsContent();
  }, [props?.newSteps, nextStageDetails]);

  const navigate = useNavigate();


  const updateStepsContent = () => {
    // const baseSteps = [
    //   {
    //     title: "Upload Docs",
    //     content: (
    //       <BasicDetailsContainer
    //         urlLink={props?.urlLink}
    //         setUrlLink={props?.setUrlLink}
    //         prev={props?.prev}
    //         next={props?.next}
    //         currentStep={props?.currentStep}
    //         wizardSteps={steps}
    //         handleInitiatePreAuth={props?.handleInitiatePreAuth}
    //         initiateToPreAuth={props?.initiateToPreAuth}
    //         setClaimId={props?.setClaimId}
    //       />
    //     ),
    //   },
    //   {
    //     title: "PATIENT DETAILS",
    //     content: (
    //       <PreAuthScreenContainer
    //         urlLink={props?.urlLink}
    //         setUrlLink={props?.setUrlLink}
    //         setClaimId={props?.setClaimId}
    //       />
    //     ),
    //   },
    // ];

    // let newSteps = [...baseSteps];

    // if (props?.schemeName?.toUpperCase() === "MEDI ASSIST") {
    //   if (hasEnhancement) {
    //     newSteps.push(
    //       {
    //         title: "Pre-Auth Query",
    //         content: <PreAuthQueryContainer />,
    //       },
    //       {
    //         title: "Enhancement",
    //         content: <EnhancementContainer />,
    //       }
    //     );
    //   }
    //   newSteps.push(
    //     {
    //       title: "Discharge",
    //       content: <DischargeContainer />,
    //     },
    //     {
    //       title: "CLAIM",
    //       content: <PreAuthClaimContainerIhx claimId={props?.claimId} />,
    //     }

    //   );
    // } else if (
    //   props?.schemeName?.toUpperCase() === "CGHS" ||
    //   props.schemeName?.toUpperCase() === "CAPF"
    // ) {
    //   if (props?.visitType === "OP") {
    //     newSteps.push({
    //       title: "CLAIM",
    //       content: <PreAuthClaimContainer claimId={props?.claimId} />,
    //     });
    //   } else if (
    //     props?.visitType?.toUpperCase() === "IP" ||
    //     props?.visitType?.toUpperCase() === "EMERGENCY"
    //   ) {
    //     newSteps.push(
    //       {
    //         title: "Pre-Auth Query",
    //         content: <PreAuthQueryForCghs />,
    //       },
    //       {
    //         title: "Enhancement",
    //         content: <EnhancementList />,
    //       },
    //       {
    //         title: "Discharge",
    //         content: <DischargeContainer />,
    //       },
    //       {
    //         title: "CLAIM",
    //         content: <PreAuthClaimContainer claimId={props?.claimId} />,
    //       }
    //     );
    //   }
    // } else if (props?.schemeName?.toUpperCase() === "STAR HEALTH") {
    //   newSteps.push(

    //     {
    //       title: "Discharge",
    //       content: <DischargeContainer />,
    //     },
    //     {
    //       title: "CLAIM",
    //       content: <PreAuthClaimContainer claimId={props?.claimId} />,
    //     }
    //   );
    // } else if (props?.schemeName?.toUpperCase() === "ECHS") {
    //   if (props?.visitType === "OP") {
    //     newSteps.push({
    //       title: "CLAIM",
    //       content: <PreAuthClaimContainerEchs claimId={props?.claimId} />,
    //     });
    //   } else if (
    //     props?.visitType?.toUpperCase() === "IP" ||
    //     props?.visitType?.toUpperCase() === "EMERGENCY"
    //   ) {
    //     newSteps.push(
    //       {
    //         title: "Discharge",
    //         content: <DischargeContainer />,
    //       },
    //       {
    //         title: "CLAIM",
    //         content: <PreAuthClaimContainerEchs claimId={props?.claimId} />,
    //       }
    //     );
    //   }
    // }

    const onfetchStepperClick = () => {
      props.fetchStepper();
    };

    const newBuildData = props?.newSteps?.visitStages?.map(
      (item: any, index: number) => {
        // Initialize newItem based on item (if necessary)
        let newItem = { ...item }; // Ensure newItem is a copy of the item object

        if (item) {
          const flag = true;
          if (item.visitStage?.toUpperCase() === "PATIENT REGISTRATION") {
            newItem.content = (
              <PatientDetailsContainer flag={flag} newSteps={props?.newSteps} />
            );
          } else if (item.visitStage?.toUpperCase() === "PORTAL REGISTRATION") {
            if (
              props?.patientDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
              "AYUSHMAN BHARAT"
            ) {
              newItem.content = (
                <RegistrationContainerAyushB
                  nextStage={nextStageDetails}
                  setMoveToNext={setMoveToNext}
                  claimId={props?.claimId}
                  onfetchStepper={onfetchStepperClick}
                />
              );
            } else {
              newItem.content = (
                <PreAuthScreenContainer
                  urlLink={props?.urlLink}
                  setUrlLink={props?.setUrlLink}
                  setClaimId={props?.setClaimId}
                  isScreen={item.visitStage}
                  setRegId={props?.setRegId}
                  visitStage={props?.newSteps?.visitStages}
                  nextStage={nextStageDetails}
                  setMoveToNext={setMoveToNext}
                  setRenderToTop={setRenderToTop}
                />
              );
            }
          } else if (item.visitStage === "PreAuth") {
            if (
              props?.patientDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                "CGHS" ||
              props?.patientDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                "CAPF"
            ) {
              newItem.content = (
                // <PreAuthCghsContainer
                //   // nextStage={nextStageDetails}
                //   // setMoveToNext={setMoveToNext}
                //   // claimId={props?.claimId}
                //   // setClaimId={props?.setClaimId}
                //   // onfetchStepper={onfetchStepperClick}
                // />
                <PreAuthScreenContainer
                  urlLink={props?.urlLink}
                  setUrlLink={props?.setUrlLink}
                  setClaimId={props?.setClaimId}
                  isScreen={item.visitStage}
                  setRegId={props?.setRegId}
                  visitStage={props?.newSteps?.visitStages}
                  nextStage={nextStageDetails}
                  setMoveToNext={setMoveToNext}
                  setRenderToTop={setRenderToTop}
                />
              );
            }
              if (
              props?.patientDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
              "AYUSHMAN BHARAT"
            ) {
              newItem.content = (
                <PreAuthAyushConatiner
                  nextStage={nextStageDetails}
                  setMoveToNext={setMoveToNext}
                  stepperForStatus={props?.stepperForStatus}
                // claimId={props?.claimId}
                // onfetchStepper={onfetchStepperClick}
                />
              );
            } else {
            newItem.content = (
              <PreAuthScreenContainer
                urlLink={props?.urlLink}
                setUrlLink={props?.setUrlLink}
                setClaimId={props?.setClaimId}
                isScreen={item.visitStage}
                setRegId={props?.setRegId}
                visitStage={props?.newSteps?.visitStages}
                nextStage={nextStageDetails}
                setMoveToNext={setMoveToNext}
                setRenderToTop={setRenderToTop}
              />
            );
          }
          } else if (item?.visitStage?.toUpperCase() === "PREAUTH QUERY") {
            if (
              props?.newSteps?.schemeMetaDataResponse?.schemeDescription?.toUpperCase() ==
              "MEDI ASSIST"
            ) {
              if (
                props?.visitType?.toUpperCase() === "IP" ||
                props?.visitType?.toUpperCase() === "EMERGENCY"
              ) {
                newItem.content = (
                  <PreAuthQueryForCghs onfetchStepper={onfetchStepperClick} />
                );
              } else {
                newItem.content = (
                  <PreAuthQueryForCghs onfetchStepper={onfetchStepperClick} />
                );
              }
            } else if (
              props?.newSteps?.schemeMetaDataResponse?.schemeDescription?.toUpperCase() ==
                "CGHS" ||
              props?.newSteps?.schemeMetaDataResponse?.schemeDescription?.toUpperCase() ==
                "CAPF"
            ) {
              if (
                props?.visitType?.toUpperCase() === "IP" ||
                props?.visitType?.toUpperCase() === "EMERGENCY" ||
                props?.visitType?.toUpperCase() === "OP"
              ) {
                newItem.content = (
                  <PreAuthQueryForCghs onfetchStepper={onfetchStepperClick} />
                );
              }
            } else if (
              props?.newSteps?.schemeMetaDataResponse?.schemeDescription?.toUpperCase() ==
              "ECHS"
            ) {
              if (
                props?.visitType?.toUpperCase() === "IP" ||
                props?.visitType?.toUpperCase() === "EMERGENCY"
              ) {
                newItem.content = (
                  <PreAuthQueryForCghs onfetchStepper={onfetchStepperClick} />
                );
              }
            } else {
              if (
                props?.visitType?.toUpperCase() === "IP" ||
                props?.visitType?.toUpperCase() === "EMERGENCY"
              ) {
                newItem.content = (
                  <PreAuthQueryForCghs onfetchStepper={onfetchStepperClick} />
                );
              } else {
                newItem.content = (
                  <PreAuthQueryForCghs onfetchStepper={onfetchStepperClick} />
                );
              }
            }
          } else if (item?.visitStage?.toUpperCase() === "ENHANCEMENT") {
            if (
              props?.newSteps?.schemeMetaDataResponse?.schemeDescription?.toUpperCase() ==
              "MEDI ASSIST"
            ) {
              newItem.content = (
                <EnhancementContainer onfetchStepper={onfetchStepperClick} />
              );
            } else if (
              props?.newSteps?.schemeMetaDataResponse?.schemeDescription?.toUpperCase() ==
                "CGHS" ||
              props?.newSteps?.schemeMetaDataResponse?.schemeDescription?.toUpperCase() ==
                "CAPF"
            ) {
              newItem.content = (
                <EnhancementProcedureForCghsContainer
                  onfetchStepper={onfetchStepperClick}
                />
                // <EnhancementList onfetchStepper={onfetchStepperClick} />
              );
            } else if (
              props?.newSteps?.schemeMetaDataResponse?.schemeDescription?.toUpperCase() ==
              "ECHS"
            ) {
              newItem.content = (
                <EnhancementList onfetchStepper={onfetchStepperClick} />
              );
            } else {
              newItem.content = (
                <EnhancementContainer onfetchStepper={onfetchStepperClick} />
              );
            }
          } else if (item.visitStage?.toUpperCase() === "DISCHARGE") {
            newItem.content = (
              <DischargeContainer
                onfetchStepper={onfetchStepperClick}
                nextStage={nextStageDetails}
                setMoveToNext={setMoveToNext}
                stepperForStatus={props?.stepperForStatus}
              />
            );
          } else if (item?.visitStage?.toUpperCase() === "CLAIM") {
            if (
              props?.newSteps?.schemeMetaDataResponse?.schemeDescription?.toUpperCase() ==
                "CGHS" ||
              props?.newSteps?.schemeMetaDataResponse?.schemeDescription?.toUpperCase() ==
                "CAPF" ||
              props?.newSteps?.schemeMetaDataResponse?.schemeDescription?.toUpperCase() ==
                "STAR HEALTH"
            ) {
              newItem.content = (
                <PreAuthClaimContainer
                  claimId={props?.claimId}
                  onfetchStepper={onfetchStepperClick}
                  stepperForStatus={props?.stepperForStatus}
                  nextStage={nextStageDetails}
                  setMoveToNext={setMoveToNext}
                  isScreen={props?.newSteps?.schemeMetaDataResponse?.schemeDescription?.toUpperCase()}
                />
              );
            } else if (
              props?.newSteps?.schemeMetaDataResponse?.schemeDescription?.toUpperCase() ==
              "MEDI ASSIST"
            ) {
              newItem.content = (
                <PreAuthClaimContainerIhx
                  claimId={props?.claimId}
                  onfetchStepper={onfetchStepperClick}
                  stepperForStatus={props?.stepperForStatus}
                  nextStage={nextStageDetails}
                  setMoveToNext={setMoveToNext}
                />
              );
            } else if (
              props?.newSteps?.schemeMetaDataResponse?.schemeDescription?.toUpperCase() ==
              "ECHS"
            ) {
              newItem.content = (
                <PreAuthClaimContainerEchs
                  claimId={props?.claimId}
                  onfetchStepper={onfetchStepperClick}
                  stepperForStatus={props?.stepperForStatus}
                  nextStage={nextStageDetails}
                  setMoveToNext={setMoveToNext}
                />
              );
            } else if (
              props?.newSteps?.schemeMetaDataResponse?.schemeDescription?.toUpperCase() ==
              "AYUSHMAN BHARAT"
            ) {
              newItem.content = <PreAuthClaimContainerAyushB
                stepperForStatus={props?.stepperForStatus}
              />;
            } else {
              newItem.content = (
                <PreAuthClaimContainerIhx
                  claimId={props?.claimId}
                  onfetchStepper={onfetchStepperClick}
                  stepperForStatus={props?.stepperForStatus}
                  nextStage={nextStageDetails}
                  setMoveToNext={setMoveToNext}
                />
              );
            }
          } else if (item.visitStage?.toUpperCase() === "SETTLEMENT") {
            // if (
            //   props?.newSteps?.schemeMetaDataResponse?.schemeDescription?.toUpperCase() ==
            //     "CGHS" || props?.newSteps?.schemeMetaDataResponse?.schemeDescription?.toUpperCase() ==
            //     "CAPF" ||
            //   props?.newSteps?.schemeMetaDataResponse?.schemeDescription?.toUpperCase() ==
            //     "MEDI ASSIST" ||
            //   props?.newSteps?.schemeMetaDataResponse?.schemeDescription?.toUpperCase() ==
            //     "STAR HEALTH"
            // ) {
            //   newItem.content = <SettlementContainer />;
            // }
            newItem.content = <SettlementContainer />;
          }

          // Update additional properties like canNavigate, completed, etc.
          newItem.canNavigate = newItem.canNavigate;
          newItem.completed = newItem.completed;
          newItem.isCurrentStage = item?.isCurrentStage;
          newItem.stageLevelId = item?.stageLevelId;
          newItem.visitStageId = item?.visitStageId;
          newItem.title = item?.visitStage;
          newItem.step = index;
        }

        return newItem;
      }
    );

    dispatch(props?.setWizards(newBuildData));
    setStepsContent(newBuildData);
    setLocalWizardSteps(newBuildData);
  };

  const items = useMemo(
    () =>
      stepsContent?.map((item: any) => ({
        key: item?.title,
        title: item?.title,
        step: item?.step,
        canNavigate: item?.canNavigate,
        completed: item?.completed,
      })),
    [stepsContent]
  );

  const currentWizardStep = localWizardSteps[props?.currentStep];

  const handleNameLink = () => {
    dispatch(setCurrentStep(0));
  };

  return (
    <>
      <div className="m-4" style={{ marginTop: "1.4rem" }} ref={topDivRef}>
        <div
          className="ms-panel shadow col-md-12 case-registration-container"
          style={{ marginBottom: "0px" }}
        >
          <div className="container-stepper" style={{ maxWidth: "100%" }}>
            <ul className="custom-progressbar-ul">
              {items?.map((step, index) => (
                <li
                  key={index}
                  className={`custom-progressbar-li ${
                    props?.newSteps?.currentVisitStage?.step === index
                      ? props?.newSteps?.currentVisitStage?.state ===
                        "Completed"
                        ? "completed"
                        : "current"
                      : props?.newSteps?.currentVisitStage?.step > index
                      ? "completed"
                      : ""
                  } custom-progressbar-li ${
                    currentStep === index && "active"
                  }  `}
                  onClick={(e) => props?.handleCurrentStep(step)}
                >
                  <div className="content">
                    <span>{step.title}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {currentStep !== 0 && (
            // <ExtraDetails
            //   patientDetails={props?.patientDetails?.patientResponse}
            //   schemeName={props?.schemeName}
            //   referralDetails={props?.patientDetails?.referralInfoResponse}
            //   visitDetails={props?.patientDetails?.visitInfoResponse}
            // />
            <div style={{ padding: "0 0.5rem" }}>
              <div
                className="patient-details-screen"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  // backgroundColor: "#EFF6FF",
                  border: "0.4px solid #A6A6A6",
                  borderRadius: "10px",
                  padding: "2px 0",
                  flexWrap: "wrap",
                  marginTop: "0.6rem",
                  // boxShadow: "1px 1px #00000040",
                  boxShadow: "0px -1px 4px 0px #00000040 inset",
                  marginBottom: "1.8rem",
                  background: " #008B8B0D",
                }}
              >
                <div
                  className="items"
                  style={{
                    padding: "10px 20px 0px 20px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "20%",
                  }}
                >
                  <p
                    style={{
                      marginBottom: "0.6rem",
                      fontSize: "1.2rem",
                      fontWeight: "700",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    // onClick={()=>navigate( `${ROUTES.ALL_VISIT}/${patients?.fetchBasicDetails2?.visitInfoResponse?.id}`)}
                    onClick={() => handleNameLink()}
                  >
                    {props?.patientDetails?.patientResponse?.fullName}
                  </p>
                  <p style={{ fontWeight: "600", fontSize: "0.9rem" }}>
                    #{props?.patientDetails?.patientResponse?.uhidNo || " "}
                  </p>
                </div>

                <div
                  className="items"
                  style={{
                    padding: "10px 20px 0px 20px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "15%",
                  }}
                >
                  <div>
                    {" "}
                    <p
                      style={{
                        marginBottom: "0.6rem",
                        fontSize: "0.8rem",
                        fontWeight: "400",
                      }}
                    >
                      Age
                    </p>
                    <p
                      style={{
                        fontWeight: "700",
                        fontSize: "0.8rem",
                        minHeight: "1.4rem",
                      }}
                    >
                      {props?.patientDetails?.patientResponse?.age || " "} Years
                    </p>
                  </div>
                </div>

                <div
                  className="items"
                  style={{
                    padding: "10px 20px 0px 20px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "15%",
                  }}
                >
                  <div>
                    {" "}
                    <p
                      style={{
                        marginBottom: "0.6rem",
                        fontSize: "0.8rem",
                        fontWeight: "400",
                      }}
                    >
                      Gender
                    </p>
                    <p
                      style={{
                        fontWeight: "700",
                        fontSize: "0.8rem",
                        minHeight: "1.4rem",
                      }}
                    >
                      {props?.patientDetails?.patientResponse?.sex || " "}
                    </p>
                  </div>
                </div>

                <div
                  className="items"
                  style={{
                    padding: "10px 20px 0px 20px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "16%",
                  }}
                >
                  <div>
                    {" "}
                    <p
                      style={{
                        marginBottom: "0.6rem",
                        fontSize: "0.8rem",
                        fontWeight: "400",
                      }}
                    >
                      OP/IP No.
                    </p>
                    <p
                      style={{
                        fontWeight: "700",
                        fontSize: "0.8rem",
                        minHeight: "1.4rem",
                      }}
                    >
                      {props?.patientDetails?.visitInfoResponse?.opNumber ||
                        " "}
                    </p>
                  </div>
                </div>

                <div
                  className="items"
                  style={{
                    padding: "10px 20px 0px 20px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "15%",
                  }}
                >
                  <div>
                    {" "}
                    <p
                      style={{
                        marginBottom: "0.6rem",
                        fontSize: "0.8rem",
                        fontWeight: "400",
                      }}
                    >
                      Scheme Name
                    </p>
                    <p
                      style={{
                        fontWeight: "700",
                        fontSize: "0.8rem",
                        minHeight: "1.4rem",
                      }}
                    >
                      {props?.patientDetails?.casesResponse
                        ?.schemeMetaDataName || " "}
                    </p>
                  </div>
                </div>

                <div
                  className="items"
                  style={{
                    padding: "10px 20px 0px 20px",
                    // borderRightWidth: "1px",
                    // borderRightStyle: "solid",
                    // borderRightColor: "#A6A6A6",
                    width: "15%",
                  }}
                >
                  <div>
                    {" "}
                    <p
                      style={{
                        marginBottom: "0.6rem",
                        fontSize: "0.8rem",
                        fontWeight: "400",
                      }}
                    >
                      Credit Note No.
                    </p>
                    <p
                      style={{
                        fontWeight: "700",
                        fontSize: "0.8rem",
                        minHeight: "1.4rem",
                      }}
                    >
                      {props?.patientDetails?.visitInfoResponse?.creditNumber ||
                        " "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {stepsContent?.length > 0 && (
            <div>{stepsContent[currentStep]?.content}</div>
          )}
        </div>
      </div>

      {!(
        stepsContent[currentStep]?.title == "Patient Registration" ||
        stepsContent[currentStep]?.title == "Portal registration" ||
        stepsContent[currentStep]?.title == "PreAuth" ||
        stepsContent[currentStep]?.title == "Discharge" ||
        stepsContent[currentStep]?.title == "Claim"
      ) && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "1rem",
            justifyContent: "flex-end",
          }}
        >
          {/* <Tooltip title="PREV" placement="right" color="blue"> */}
          {props?.currentStep !== 0 && (
            <Button
              style={{
                color: "#008B8B",
                background: "white",
                border: "1px solid #008B8B",
                boxShadow: "0px 2px 8px 0px #00000040",
                borderRadius: "10px",
                padding: "12px 25px",
              }}
              // type={props?.currentStep > 0 ? "primary" : undefined}
              onClick={() => props?.prev()}
              disabled={false}
            >
              PREVIOUS
            </Button>
          )}
          {/* </Tooltip> */}

          {/* <Tooltip title="NEXT" placement="left" color="blue"> */}
          {localWizardSteps?.length - 1 !== props?.currentStep && (
            <Button
              style={{
                background: "#008B8B",
                border: "1px solid #008B8B",
                boxShadow: "0px 2px 8px 0px #00000040",
                borderRadius: "10px",
                padding: "12px 25px",
                marginLeft: "0.8rem",
                color: "white",
                opacity:
                  currentWizardStep?.canNavigate &&
                  !(
                    !currentWizardStep?.canNavigate &&
                    !currentWizardStep?.completed
                  )
                    ? 1
                    : 0.5, // Fading effect for disabled
              }}
              onClick={
                currentWizardStep?.canNavigate && currentWizardStep?.steps === 0
                  ? () => {
                      props?.handleInitiatePreAuth();
                    }
                  : currentWizardStep?.canNavigate
                  ? () => {
                      props?.next();
                    }
                  : undefined
              }
              disabled={
                (!currentWizardStep?.canNavigate &&
                  !currentWizardStep?.completed) ||
                localWizardSteps?.length - 1 === props?.currentStep
              }
            >
              NEXT: {nextStageDetails?.visitStage}
            </Button>
          )}

          {/* </Tooltip> */}
        </div>
      )}

      <div></div>
    </>
  );
};

export default PreAuthStepper;
